import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';

export async function sendAgentReminderEmail(emailParams: {
  serviceRequestId: string;
  subject: string;
  details: string;
}) {
  try {
    const res = await fetcher(
      `${API_BASE_PATH}/send-agent-reminder-email`,
      {
        method: 'POST',
        body: emailParams,
      },
      undefined
    );

    return res;
  } catch (err) {
    console.error(err);
    return err;
  }
}
